<template>
	<b-container class="w-75 text-dark m-auto p-0">
		<b-row no-gutters class="text-center" v-if="$asyncComputed.workspace.success && workspace">
			<b-col>
				<RingLoader :color="'#343a40'" :size="64" :loading="true" class="m-auto py-5" />
				<h3 class="heading">{{ stateMessage(workspace.state).heading }}</h3>
				{{ stateMessage(workspace.state).message }}
			</b-col>
		</b-row>
		<elumin-loader v-else />
	</b-container>
</template>

<script>
	import { RingLoader } from '@saeris/vue-spinners';
	import stateMessages from '@/components/Desktop/stateMessages';
	
	export default
	{
		name: 'desktop-launch',
		components: { RingLoader },
		props: [ 'type', 'poolUUID', 'wsUUID' ],
		asyncComputed:
		{
			workspace:
			{
				lazy: false,
				async get()
				{
					let ws = await this.portalAPI.get('/desktop/' + this.type + '/' + ((this.type === 'oal') ? this.poolUUID : this.wsUUID))
						.then(
							resp => resp.data,
							err => err
						);
					
					this.$logger.debug('WS loaded', ws)
					
					return ws;
				}
			}
		},
		computed:
		{
			portalAPI: function()
			{
				return this.$root.$refs.app.portalAPI;
			}
		},
		methods:
		{
			startWS: async function()
			{
				let result = await this.portalAPI.post('/desktop/' + this.type + ((this.type === 'oal') ? '/' + this.poolUUID : '') + '/start/' + this.wsUUID)
					.then(
						resp => resp.data
					);
				
				this.$logger.info('Start Workspace');
			},
			loginWS: async function()
			{
				let result = await this.portalAPI.post('/desktop/' + this.type + ((this.type === 'oal') ? '/' + this.poolUUID : '') + '/login/' + this.wsUUID)
					.then(
						resp => resp.data
					);
				
				this.$logger.info('Workspace Login');
				
				if('WebAccessURL' in result)
					window.location.href = result.WebAccessURL;
			},
			stateMessage: function(state)
			{
				return ((state in stateMessages) ? stateMessages[state] : Object.assign(stateMessages['_DEFAULT'], { message: 'State: ' + state }));
			}
		},
		timers:
		{
			refresh:
			{
				callback: function() { this.$asyncComputed.workspace.update(); },
				autostart: true,
				repeat: true,
				immediate: false,
				time: 1000 * 30
			}
		},
		watch:
		{
			'workspace.state':
			{
				handler: function(nVal, oVal)
				{
					switch(nVal)
					{
						case 'STOPPED':
							this.startWS();
							break;
						case 'AVAILABLE':
							this.loginWS();
							break;
					}
					
					return nVal;
				},
				immediate: true
			}
		},
		data() { return {}; }
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.container
	{
		height: 100%;
		max-height: 100%;
		
		overflow: auto;
		
		padding: 12px;
	}
	
	.fade-enter-active, .fade-leave-active
	{
		transition: all 0.25s;
	}
	
	.fade-enter, .fade-leave-to
	{
		opacity: 0;
	}
	
</style>
